// This file generates a code challenge for OAuth flows using the SHA-256 hashing algorithm and Base64 URL encoding.
import { base64UrlEncode } from "./base64UrlEncode";
import { convertBufferToString } from "./convertBufferToString";

export async function generateCodeChallenge(codeVerifier: string) {
  const digestOp = await crypto.subtle.digest(
    { name: "SHA-256" },
    new TextEncoder().encode(codeVerifier),
  );
  const hash = convertBufferToString(digestOp);
  return base64UrlEncode(hash);
}
